import axios from "axios"
import ENV from "../config/env"

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'

const dispatchLogin = (type, payload) => ({type: type, payload: payload})

export const login = data => dispatch => {
    return axios.post(`${ENV.API}/auth/login`, data)
        .then(async res => {
            if (res.data.errmsg) alert(res.data.errmsg)
            else if (res.data.token !== undefined && res.data.token !== "") {
                //On dispatch les infos
                dispatch(dispatchLogin(LOGIN, res.data))
                await localStorage.setItem('token', res.data.token)
                await localStorage.setItem('admin', res.data.admin)
                await localStorage.setItem('mail', res.data.mail)
                await localStorage.setItem('idClub', res.data.idClub)
                //On redirige vers le Dashboard ou le club
                res.data.admin === "true" ? window.location.href = '/dashboard' : window.location.href = `/club/${res.data.idClub}`
            }
        })
        .catch(err => {
            console.log(err)
        })
}

export const guest = () => async dispatch => {
    dispatch(dispatchLogin(LOGIN, {token: "guest"}))
    await localStorage.setItem('token', 'guest')
    window.location.href = '/create-licence'
}

export const logout = () => async dispatch => {
    await localStorage.removeItem('token')
    await localStorage.removeItem('admin')
    await localStorage.removeItem('persist:3fts')
    dispatch(dispatchLogin(LOGOUT, false))
}
